module.exports = __webpack_public_path__ + "static/media/coat-arms.a74d9e64.png";